module.exports = __webpack_public_path__ + "static/media/iiitk_logo.bdb822ed.png";